export default {"src":"/_next/static/media/dentalOutline50_40.ca06fbff.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};